import { Response } from "../../../model";
import ServiceBase from "../../servicebase";

type Servicios = "SEGURIDAD" | "CLIENTES";

export default class ResourceService extends ServiceBase {
  getImgSrc = (servicio: Servicios, id?: number) => `${this.urlAPI}resource/redirect?servicio=${servicio}&id=${id}`;
  redirect = (servicio: Servicios, id?: number) => this.GetFetch<void>("resource/redirect", { servicio, id });
  url = (servicio: Servicios, id?: number) => this.GetFetch<Response<string>>("resource/url", { servicio, id });
}
